import { render, staticRenderFns } from "./website-learning.vue?vue&type=template&id=33731562&scoped=true"
import script from "./website-learning.vue?vue&type=script&lang=js"
export * from "./website-learning.vue?vue&type=script&lang=js"
import style0 from "./website-learning.vue?vue&type=style&index=0&id=33731562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33731562",
  null
  
)

export default component.exports